// @ts-nocheck
import Events from './constants/events';

type Callback = () => void;

export function getCurrentDomain() {
  return process.env.HOSTNAME || window.location.hostname;
}

interface DocumentWithAttachEvent extends Document {
  attachEvent?: (event: string, callback: () => void) => void;
}

export function onPageReady(callback: Callback): void {
  if (document.readyState !== 'loading') {
    callback();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', callback);
  } else {
    (document as DocumentWithAttachEvent).attachEvent?.(
      'onreadystatechange',
      () => {
        if (document.readyState === 'complete') {
          callback();
        }
      },
    );
  }
}

export function onConcordLoaded(callback: Callback) {
  if (window.concord) {
    callback();
  } else {
    window.addEventListener(Events.Loaded, callback);
  }
}

export function onConcordConfigLoaded(callback: Callback) {
  if (window.concord && window.concord.loaded) {
    callback();
  } else {
    window.addEventListener(Events.LoadedConfig, callback);
  }
}

export function onConcordReady(callback: Callback) {
  if (window.concord && window.concord.ready) {
    callback();
  } else {
    window.addEventListener(Events.Ready, callback);
  }
}
